export default "__VITE_ASSET__Cz1u8hZI__"